import {LIST_LOAN, FETCH_LOAN, CLEAR_LOAN, MODIFIED_LOAN, LOADING_LOAN} from "./types";

const init = {
    isLoading: false,
    data: [],
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_LOAN:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_LOAN:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_LOAN:
            return {
                isLoading: false,
                data: []
            };
        case MODIFIED_LOAN:
            return {
                ...state,
                isLoading: true
            };
        case LOADING_LOAN:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}